module.exports = __webpack_public_path__ + "static/img/bg-color-tips.33ad71c1.png";